import React from 'react';
import { HomeSlider, Categories, Ourstore, Banner, Newproduct } from '../../components';

const Home = () => {
  return (
    <>
      <HomeSlider />
      <Categories />
      <Ourstore />
      <Banner />
      <Newproduct />
    </>
  )
}

export default Home;